import './PdcListItem.scss'

import { IconCategory } from '@here/hds-iconlibrary/build/hds-iconlibrary'
import { HDSIcon } from '@here/hds-react-components'
import classNames from 'classnames'
import ListItem from 'components/App/components/ListItem'
import SvgPdsIcon from 'components/Map/components/SvgPdsIcon'
import React from 'react'
import { formatExternalLinkText } from 'utils/formatters'

interface PdcListItemProps {
  type: PdcListItemType
  icon: string
  iconCategory?: IconCategory
  value: string
  label?: string
  onCopy?: () => void
}

type PdcListItemType = 'category' | 'email' | 'label' | 'position' | 'phone' | 'web'

function formatExternalLinkUrl(type: PdcListItemType, value: string): string {
  if (type === 'email') {
    return `mailto:${value}`
  }

  if (type === 'phone') {
    return `tel:${value}`
  }

  return value
}

const hdsIconStyle = {
  '--hds-icon-color': 'var(--hds-action)',
} as React.CSSProperties

export default function PdcListItem({
  type,
  icon,
  iconCategory,
  value,
  label,
  onCopy,
}: PdcListItemProps): JSX.Element {
  const linksType = ['email', 'web', 'phone']
  const [hovered, setHovered] = React.useState(false)

  const PdcListItemBody = (): JSX.Element => (
    <div className="PdcListItem">
      {type === 'category' ? (
        <SvgPdsIcon className="PdcListItem__category-icon" categoryId={icon} />
      ) : (
        <HDSIcon name={icon} category={iconCategory} style={hdsIconStyle} iconStyle="solid" />
      )}

      <span className="PdcListItem__label">
        {label !== undefined ? (
          label
        ) : (
          <>{type === 'web' ? formatExternalLinkText(value) : value}</>
        )}
      </span>
      {onCopy !== undefined && hovered && (
        <HDSIcon
          name="copy"
          category="file"
          size="16px"
          iconStyle="solid"
          className="PdcListItem__copy-icon"
        />
      )}
    </div>
  )

  return (
    <ListItem
      className={classNames('PdcListItemWrapper PdcListItemWrapper--separated', {
        'PdcListItemWrapper--link': linksType.includes(type) || type === 'category',
      })}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onCopy}
    >
      {linksType.includes(type) ? (
        <a target="_blank" rel="noreferrer" href={formatExternalLinkUrl(type, value)}>
          <PdcListItemBody />
        </a>
      ) : (
        <PdcListItemBody />
      )}
    </ListItem>
  )
}
